import { z } from 'zod'
import { SystemCatalogItemStatusSchema } from '../system_catalog/system_catalog.schema'

// Schema for the global_category object
const GlobalCategorySchema = z.object({
  id: z.number(),
  status: z.string(),
  name: z.string(),
})

// Schema for program_items array items
const ProgramItemSchema = z.object({
  id: z.number(),
  status: SystemCatalogItemStatusSchema,
  program_item_category_id: z.number(),
  program_item_id: z.number().optional(),
  service_fee: z.number(),
  global_item_name: z.string(),
  global_item_id: z.number(),
  global_item: z.object({
    type: z.number(),
  }),
})

export type ProgramItem = z.infer<typeof ProgramItemSchema>

// Main schema for the program category objects
const ProgramCategorySchema = z.object({
  id: z.number(),
  status: SystemCatalogItemStatusSchema,
  program_id: z.number(),
  global_item_category_id: z.number(),
  service_fee: z.number(),
  apply_service_fee_to_items: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  global_category_name: z.string(),
  program_items: z.array(ProgramItemSchema),

  global_category: GlobalCategorySchema,
})
export type ProgramCategory = z.infer<typeof ProgramCategorySchema>
// Schema for the array of program categories
const ProgramCategoriesSchema = z.array(ProgramCategorySchema)

export {
  ProgramCategoriesSchema,
  ProgramCategorySchema,
  ProgramItemSchema,
  GlobalCategorySchema,
}
